import { useFieldArray, UseFieldArrayReturn, useFormContext } from 'react-hook-form';
import { FormValues } from './EstatePlanningCharitableDonations.meta';

export type DonationsFieldArray = UseFieldArrayReturn<FormValues, 'Donations', 'key'>;

export const useDonationFieldArray = (): DonationsFieldArray => {
  const formBag = useFormContext<FormValues>();

  const fieldName = 'Donations';

  const fieldArrayBag = useFieldArray({
    control: formBag.control,
    name: fieldName,
    keyName: 'key',
  });
  const watchFieldArray = formBag.watch(fieldName);
  const controlledFields = watchFieldArray
    ? fieldArrayBag.fields.map((field, index) => {
        return {
          ...field,
          ...watchFieldArray[index],
        };
      })
    : [];

  return {
    ...fieldArrayBag,
    fields: controlledFields,
  };
};
